module.exports = __webpack_public_path__ + "img/Loading.0141de70.gif";